import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=45edf1b0"
var script = {}
import style0 from "./authentication.vue?vue&type=style&index=0&id=45edf1b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports